class JfcProductsMegaMenu extends HTMLElement {
  connectedCallback() {
    this.header = this.closest('header-menu');
    this.trigger = this.header?.querySelector('[data-jfc-products-trigger]');
    this.panel = this.querySelector('[data-jfc-stage]');
    this.closeButton = this.querySelector('.jfc-products-menu__close');
    if (!this.trigger || this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.trigger.addEventListener('click', (event) => {
      if (window.matchMedia('(min-width: 990px)').matches) {
        event.preventDefault();
        this.open();
      }
    });
    this.trigger.addEventListener('pointerenter', () => {
      if (window.matchMedia('(min-width: 990px) and (hover: hover)').matches) {
        this.cancelClose();
        this.open();
      }
    });
    this.trigger.addEventListener('pointerleave', () => this.scheduleClose());
    this.panel?.addEventListener('pointerenter', () => this.cancelClose());
    this.panel?.addEventListener('pointerleave', () => this.scheduleClose());
    this.querySelector('.jfc-products-menu__backdrop')?.addEventListener('pointerenter', () => this.scheduleClose(80));
    this.querySelectorAll('[data-jfc-menu-close]').forEach((button) => button.addEventListener('click', () => this.close()));
    this.querySelectorAll('[data-jfc-mode]').forEach((button) => button.addEventListener('click', () => this.selectMode(button.dataset.jfcMode)));
    this.querySelectorAll('[data-jfc-category]').forEach((button) => {
      button.addEventListener('click', () => this.selectCategory(button.dataset.jfcCategory));
      button.addEventListener('pointerenter', () => this.selectCategory(button.dataset.jfcCategory));
    });
    this.querySelectorAll('[data-jfc-product]').forEach((button) => {
      button.addEventListener('click', () => this.selectProduct(button.dataset.jfcProduct));
      button.addEventListener('pointerenter', () => this.selectProduct(button.dataset.jfcProduct));
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.hidden) this.close();
    });
  }

  open() {
    this.cancelClose();
    const headerRoot = document.querySelector('#header-component') || document.querySelector('header');
    const bottom = headerRoot?.getBoundingClientRect().bottom || 80;
    this.style.setProperty('--jfc-products-menu-top', `${Math.max(0, bottom)}px`);
    this.hidden = false;
    requestAnimationFrame(() => this.classList.add('is-open'));
    this.resetToFirstColumn();
    this.trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('jfc-products-menu-open');
  }

  close(restoreFocus = true) {
    this.cancelClose();
    this.classList.remove('is-open');
    this.trigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('jfc-products-menu-open');
    this.closeTimer = window.setTimeout(() => {
      this.hidden = true;
      if (restoreFocus) this.trigger.focus({ preventScroll: true });
    }, 180);
  }

  scheduleClose(delay = 140) {
    if (this.hidden) return;
    this.cancelClose();
    this.closeTimer = window.setTimeout(() => this.close(false), delay);
  }

  cancelClose() {
    if (this.closeTimer) window.clearTimeout(this.closeTimer);
    this.closeTimer = null;
  }

  selectMode(mode) {
    this.querySelectorAll('[data-jfc-mode]').forEach((button) => {
      const selected = button.dataset.jfcMode === mode;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-selected', String(selected));
    });
    this.querySelectorAll('[data-jfc-mode-panel]').forEach((panel) => {
      const selected = panel.dataset.jfcModePanel === mode;
      panel.hidden = !selected;
      panel.classList.toggle('is-active', selected);
    });
    this.resetToFirstColumn();
  }

  selectCategory(category) {
    const modePanel = this.querySelector(`[data-jfc-category="${CSS.escape(category)}"]`)?.closest('[data-jfc-mode-panel]');
    if (!modePanel) return;
    modePanel.querySelectorAll('[data-jfc-category]').forEach((button) => {
      const selected = button.dataset.jfcCategory === category;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    modePanel.querySelectorAll('[data-jfc-model-list]').forEach((list) => { list.hidden = list.dataset.jfcModelList !== category; });
    modePanel.querySelectorAll('[data-jfc-product]').forEach((button) => {
      button.classList.remove('is-active');
      button.setAttribute('aria-pressed', 'false');
    });
    modePanel.querySelectorAll('[data-jfc-product-preview]').forEach((preview) => { preview.hidden = true; });
    this.setStage(2);
  }

  selectProduct(product) {
    const modePanel = this.querySelector(`[data-jfc-product="${CSS.escape(product)}"]`)?.closest('[data-jfc-mode-panel]');
    if (!modePanel) return;
    modePanel.querySelectorAll('[data-jfc-product]').forEach((button) => {
      const selected = button.dataset.jfcProduct === product;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    modePanel.querySelectorAll('[data-jfc-product-preview]').forEach((preview) => { preview.hidden = preview.dataset.jfcProductPreview !== product; });
    this.setStage(3);
  }

  resetToFirstColumn() {
    this.querySelectorAll('[data-jfc-category], [data-jfc-product]').forEach((button) => {
      button.classList.remove('is-active');
      button.setAttribute('aria-pressed', 'false');
    });
    this.querySelectorAll('[data-jfc-model-list], [data-jfc-product-preview]').forEach((item) => { item.hidden = true; });
    this.setStage(1);
  }

  setStage(stage) {
    if (!this.panel) return;
    this.panel.dataset.jfcStage = String(stage);
    if (this.closeButton) this.closeButton.hidden = stage < 3;
  }
}

if (!customElements.get('jfc-products-mega-menu')) customElements.define('jfc-products-mega-menu', JfcProductsMegaMenu);
